import { AdminThemeDto } from '@api/types/themes'
import { ConfirmDialog } from '@components/common/ConfirmDialog'

interface ThemeDeleteDialogProps {
  open: boolean
  theme: AdminThemeDto | null
  deleting: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * Thin wrapper over the shared <ConfirmDialog> so the page keeps its own prop shape while the
 * confirmation itself (mobile full-screen, disabled-while-running, destructive colouring) is the
 * portal's one implementation.
 */
export function ThemeDeleteDialog({ open, theme, deleting, onClose, onConfirm }: ThemeDeleteDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      title="Delete Theme"
      message={
        <>
          Are you sure you want to delete <strong>{theme?.name}</strong>?
          {theme && theme.userCount > 0 && (
            <> This theme is currently assigned to {theme.userCount} user(s).</>
          )}
        </>
      }
      confirmLabel={deleting ? 'Deleting...' : 'Delete'}
      destructive
      loading={deleting}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  )
}
